import React from 'react';
import { useQuery } from '@apollo/client/react';
import { useParams, useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import BreadcrumbContainer from 'components/layout/breadcrumb_container';
import ShowQuery from 'queries/inspection_result/show';
import ShowItem from 'components/inspection_result/show_item';
import TopMenu from 'components/layout/top_menu';
import LoaderContainer from 'components/layout/loader_container';
import { InspectionsLink, InspectionLink } from 'utils/link';
import { useError } from 'contexts/error';
import { BreadCrumbLink } from 'components/styles_components/link';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import Date from 'components/date';

const InspectionResult = () => {
  const setError = useError();
  const navigate = useNavigate();
  const { inspectionResultId } = useParams();
  const {
    data = { inspectionResult: { inspection: {} }, space: {} },
    loading,
    error,
    refetch,
  } = useQuery(ShowQuery, {
    variables: { id: inspectionResultId },
    onError: () => {
      setError('error.inspection_result.show');
      navigate(InspectionsLink());
    },
  });

  return (
    <>
      <TopMenu>
        <BreadcrumbContainer>
          <BreadCrumbLink to={InspectionsLink()}>
            <FormattedMessage id="breadcrumb.inspections.index" />
          </BreadCrumbLink>
          {data.inspectionResult.inspection && (
            <BreadCrumbLink to={InspectionLink(data.inspectionResult.inspection.id)}>{data.inspectionResult.inspection.name}</BreadCrumbLink>
          )}
          <BreadCrumbTypography>
            <FormattedMessage id="inspection.result" /> <Date date={data.inspectionResult.doneAt} />
          </BreadCrumbTypography>
        </BreadcrumbContainer>
      </TopMenu>
      <LoaderContainer loading={loading} error={error}>
        {data.inspectionResult && (
          <ShowItem
            inspectionResult={data.inspectionResult}
            space={data.space}
            refetch={refetch}
          />
        )}
      </LoaderContainer>
    </>
  );
};

export default InspectionResult;
